module.exports = __webpack_public_path__ + "static/media/cec.a9d50148.png";